import cart from "../images/cart.png";
import xenia from "../images/xenia.png";
import crypto from "../images/crypto.png";
import crypto1 from "../images/pb.jpg";
import portal from "../images/portal.png";
import mystery from "../images/mystery-match.jpeg";

import xeniaverse from "../images/xeniaverse.png";
import squid from "../images/squid_game.png";
import estate from "../images/estate.png";
import townhall from "../images/Townhall.png";
import courier from "../images/courierMarketplace.png";
import gamex from "../images/game-x.png";
import digiwork from "../images/digiwork.png";
import hms from "../images/HMS.jpg";
export const projectsData = [
  {
    name: " Decentralized Courier Marketplace",
    description:
      "Ai based courier marketplace with development of multiple agents to enhance and optimize delivery system",
    image: courier,
    code: "",
    techStack: [
      "React JS",
      "Docker",
      "PostgreSQL",
      "FastAPI",
      "Twilio Services",
    ],
    deployment: "",

    // sysArch: "https://www.pcsbxenia.com/",
  },
  {
    name: "XENIA",
    description:
      "We made this site to facilitate a plethora of essential functions of this nation-wide tech-fest. From registrations, displaying content to payments everything was made from scratch and integrated together.",
    image: xenia,
    code: "",
    techStack: ["React JS", "Mongo DB", "Node JS"],
    deployment: "https://xenia-2.netlify.app/",

    // sysArch: "https://www.pcsbxenia.com/",
  },
  {
    name: "Hospital Management System",
    description:
      "The Hospital Management System (HMS) is a web application designed to streamline the management of hospital services. It enables efficient handling of patient details, doctor appointments, and other hospital operations. The system caters to three types of users: Admins, Hospital Staff, and Doctors, each with specific privileges and functionalities.",
    image: hms,
    code: "",
    deployment: "https://github.com/yash797/hospital-management-system",
    techStack: [
      "HTML",
      "Tailwind CSS",
      "JavaScript",
      "Java",
      // "Cloudinary",
      // "Terraform",
    ],

    // sysArch: "https://sysarch.burhanuddinmerchant.me/fnf.html",
  },

  {
    name: "Crypto Stalker",
    description:
      "Primary goal of this web application is to track different Crpytocurrencies’ information. Real time value of cryptocurrencies,their exchange rates in USD and INR, its change in price in last 24 hrs/ 30 days/ 3 months/ 1 year and current market cap is shown.",
    image: crypto,
    code: "",
    deployment: "https://cryptostalker.netlify.app/",
    techStack: [
      "React JS",
      "Material UI",
      "Chart JS",
      // "Docker",
      // "Cloudinary",
      // "Terraform",
    ],
    // sysArch: "https://sysarch.burhanuddinmerchant.me/fnf.html",
  },
  {
    name: "Squid Game",
    description:
      "Tried to design an online game that contains captivating graphics from the series that will appeal to users. Squid game's user-friendly interface aimed to give the user a first-hand experience of squid game.",
    image: squid,

    deployment: "/squid-game",
    techStack: ["Photoshop"],
  },

  {
    name: "Project Buddy",
    description:
      "A college student networking platform designed to facilitate seamless communication and collaboration for academic projects and hackathons.",
    image: crypto1,
    code: "",
    deployment: "https://project-buddy.netlify.app/",
    techStack: [
      "React JS",
      "Tailwind CSS",
      "Django",
      "PostgressSQL",
      // "Cloudinary",
      // "Terraform",
    ],
    // sysArch: "https://sysarch.burhanuddinmerchant.me/fnf.html",
  },

  {
    name: "Mystery Match",
    description:
      "The Mystery Match is a web-platform connecting Sherlock Holmes with potential assistant detectives, allowing the latter to submit their resumes and showcase their skills, and the former to easily browse and select the best fit for their cases. The platform also allows for direct communication and updates on the status of applications.",
    image: mystery,
    code: "",
    deployment: "https://mystery-match.netlify.app/",
    techStack: ["React JS", "Tailwind CSS", "CSS", "JQuery"],
  },

  {
    name: "Registration Portal",
    description:
      "The registration portal is a web-based platform designed by a team to facilitate the registration process for students of PICT College who want to join the Technical Club i.e PCSB. The portal streamlines the registration process and makes it easy for students to sign up and become a member of the club.",
    image: portal,
    code: "",
    deployment: "https://csi-registration-portal.netlify.app/",
    techStack: [
      "React JS",
      "Tailwind CSS",
      "Go Lang",
      // "Docker",
      // "Cloudinary",
      // "Terraform",
    ],
    // sysArch: "https://sysarch.burhanuddinmerchant.me/fnf.html",
  },

  {
    name: "Xeniaverse",
    description:
      "The site was made to deploy information of different events and collect registrations for the same.",
    image: xeniaverse,
    code: "",
    deployment: "https://www.xeniaverse.co.in/",
    techStack: [
      "React JS",
      "Tailwind CSS",
      // "MongoDB",
      // "Docker",
      // "Cloudinary",
      // "Terraform",
    ],
    // sysArch: "https://sysarch.burhanuddinmerchant.me/fnf.html",
  },
  {
    name: "Voice-Kart",
    description:
      "Voice Kart is an E-commerce website that utilizes Alan AI to offer voice-based shopping. Customers can browse and purchase products through voice commands, making online shopping convenient and hands-free. It combines voice technology with a traditional interface for a unique shopping experience. ",
    image: cart,
    // code: "",
    deployment: "https://voicekart.netlify.app/",
    techStack: ["ReactJS", "Alan AI", "Tailwind CSS"],
  },

  {
    name: "Townhall Estates",
    description:
      "Townhall Estates is a single-page React app that allows users to filter real estate listings by move-in date, property type, country, and price range, as well as search by property name.",
    image: townhall,
    code: "",
    deployment: "https://townhall-estates.netlify.app/",
    techStack: ["React JS", "Tailwind CSS", "CSS"],
  },

  {
    name: "Game-X",
    description:
      "Game-X was developed to download and convey information of different games of different genres.",
    image: gamex,

    deployment: "https://nikitak27.github.io/Web-weaver_GameX/index.html",
    techStack: ["HTML", "CSS", "Javascript"],
  },

  {
    name: "Estate",
    description:
      "Made an extensive wireframe using figma for a real estate buisness' end to end website",
    image: estate,
    // code: "",
    deployment:
      "https://www.figma.com/proto/F54Q99NowY9Tdy0YBeZBKU/Estate_Project?node-id=150%3A120&scaling=min-zoom&page-id=0%3A1&starting-point-node-id=150%3A120",
    techStack: ["Figma"],
  },

  {
    name: "Digital Work",
    description: "Click to see all of my digital work",
    image: digiwork,
    // code: "https://github.com/RohinBhat/node-chat-app",
    deployment:
      "https://drive.google.com/drive/folders/1QkWyPUzxKtE3qSqLB9LuVxu_2a1Vbz81?usp=sharing",
    techStack: [
      "Photoshop",
      "Illustrator",
      "Indesign",
      "Canva",
      // "CSS",
      // "Handlebars",
    ],
  },

  // {
  //   name: "Mess Menu Finder",
  //   description: "Ongoing",
  //   image:
  //     "https://images.hindustantimes.com/rf/image_size_960x540/HT/p2/2019/08/07/Pictures/_ec38addc-b906-11e9-a203-e6c4ad816de5.jpg",
  //   // code: "",
  //   techStack: ["React JS", "Mongo DB", "Node JS"],
  // },
];
